import { useEffect } from 'react';

import plusFill from '@iconify/icons-eva/close-circle-outline';
import { Icon } from '@iconify/react';

import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// material
import { Button, Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

//
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { ClubForm } from '../components/club';
import { useTranslation } from '../common/LocalizationProvider';
import { selectGroupsArray } from '../createSelectorUtils';
// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '50vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function EditClub() {
  const t = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const group = useSelector(selectGroupsArray).find(
    (item) => item.id === (location.state !== null ? location.state.id : 0)
  );

  useEffect(() => {
    if (location.state === null || group === undefined) navigate('/club', { replace: true });
  }, [group, location.state, navigate]);

  return (
    <Page title={t('editClub_Title')}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('editClub')}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/club', { replace: true })}
            startIcon={<Icon icon={plusFill} />}
            color="secondary"
          >
            {t('btn_Cancel')}
          </Button>
        </Stack>
        <Scrollbar>
          <ContentStyle>
            <ClubForm groupId={location.state !== null ? location.state.id : 0} group={group} />
          </ContentStyle>
        </Scrollbar>
      </Container>
    </Page>
  );
}
